import styles from './resources.module.scss';

export const resourcesItemMemorial = [
  {
    title: 'AboutGrief.ca',
    imageUrl: '/img/general/about-grief.ca.png',
    siteUrl:'https://aboutgrief.ca',
    text: (
      <p className="my-20 colorNavy">
        <a 
          className={styles.http_link}
          href={"https://aboutgrief.ca"} 
          target={'_blank'}
        >AboutGrief.ca </a>
         is a free resource developed by the Canadian Grief Alliance with grief specialists and 
        members of the public who shared their diverse grief experiences, challenges and what helped them. 
        Articles, resources, and videos provide practical and helpful information you can trust.
      </p>
    )
  },
  {
    title: 'MyGrief.ca',    
    imageUrl: '/img/general/myGrief.ca.jpg',
    siteUrl:'https://www.mygrief.ca',
    text: (
      <>
        <p className="my-20 colorNavy">
          Confidential and free,{''} 
          <a 
            className={styles.http_link} 
            href={"https://www.mygrief.ca"} 
            target={'_blank'}
          >{''} MyGrief.ca {''}</a>
          helps you to understand and move through your grief.
        </p>
        <ul className='colorNavy'>
          <li className={styles.list_item}>
            <span className={`${styles.list_dot} ${styles['no-indent-dot']}`}></span>In your own
            place, at your own pace
          </li>
          <li className={styles.list_item}>
            <span className={`${styles.list_dot} ${styles['no-indent-dot']}`}></span>Developed by
            people who have "been there" and and grief specialists
          </li>
          <li className={styles.list_item}>
            <span className={`${styles.list_dot} ${styles['no-indent-dot']}`}></span>Features
            "real life" stories and experiences in their life is dying or has died. It equips
            parents with the words and confidence needed to help children grieve life’s losses in
            healthy ways.
          </li>
        </ul>
      </>
    )
  },
  {
    title: 'KidsGrief.ca',    
    imageUrl: '/img/general/kidsGrief.ca.jpg',
    siteUrl:'https://www.kidsgrief.ca',
    text: (
      <p className="my-20 colorNavy">
        <a 
          className={styles.http_link} 
          href={"https://www.kidsgrief.ca"} 
          target={'_blank'}
        >KidsGrief.ca {''}</a>
      is a free online resource that helps parents support their children when
      someone in their life is dying or has died. It equips parents with the words and
      confidence needed to help children grieve life’s losses in healthy ways.
      </p>
    )
  },
  {
    title: 'YouthGrief.ca',    
    imageUrl: '/img/general/youth-grief.ca.png',
    siteUrl:'https://youthgrief.ca',
    text: (
      <p className="my-20 colorNavy">
          <a 
            className={styles.http_link} 
            href={"https://youthgrief.ca"} 
            target={'_blank'}
          >YouthGrief.ca {''}</a>
          has been developed — from content to art to design — by grieving youth, for grieving youth. 
          It shares wisdom, experiences, and advice from more than 30 young people who’ve been there and know what 
          it’s like to grieve when someone you care about has died.
        </p>
    )
  }
]

export const resourcesItemMemorialFR = [
  {
    title: 'Ledeuil.ca',
    imageUrl: '/img/general/about-grief.ca.png',
    siteUrl:'https://ledeuil.ca/',
    text: (
      <p className="my-20 colorNavy">
        <a 
          className={styles.http_link} 
          href={"https://ledeuil.ca/"} 
          target={'_blank'}
        >Ledeuil.ca {''}</a>
        is a free resource developed by the Canadian Grief Alliance with grief specialists and 
        members of the public who shared their diverse grief experiences, challenges and what helped them. 
        Articles, resources, and videos provide practical and helpful information you can trust.
      </p>
    )
  },
  {
    title: 'Mondeuil.ca',    
    imageUrl: '/img/general/myGrief.ca.jpg',
    siteUrl:'https://mondeuil.ca/',
    text: (
      <>
      <p className="my-20 colorNavy">
          Confidentiel et gratuit, 
          <a 
            className={styles.http_link} 
            href={"https://mondeuil.ca/"} 
            target={'_blank'}
          >{''} Mondeuil.ca {''}</a>
          vous aidera à comprendre votre deuil et à y faire face. On y trouve de l’information par type de relation (par exemple, décès du conjoint, d’un parent, d’une collègue, d’un enfant) et de situation (par exemple, suicide, consommation de substances, perte traumatique, deuil prolongé).
        </p>
        <ul className='colorNavy'>
          <li className={styles.list_item}>
            <span className={`${styles.list_dot} ${styles['no-indent-dot']}`}></span>Dans le confort de votre foyer
          </li>
          <li className={styles.list_item}>
            <span className={`${styles.list_dot} ${styles['no-indent-dot']}`}></span>À votre rythme
          </li>
          <li className={styles.list_item}>
            <span className={`${styles.list_dot} ${styles['no-indent-dot']}`}></span>Développé par des personnes qui sont « passées par là » et des spécialistes du deuil
          </li>
        </ul>
      </>
    )
  },
  {
    title: 'Deuildesenfants.ca',    
    imageUrl: '/img/general/kidsGrief.ca.jpg',
    siteUrl:'https://deuildesenfants.ca/',
    text: (
      <p className="my-20 colorNavy">
        <a 
          className={styles.http_link} 
          href={"https://deuildesenfants.ca/"} 
          target={'_blank'}
        >Kidsgrief.ca {''}</a>
      is a free online resource that helps parents support their children when
      someone in their life is dying or has died. It equips parents with the words and
      confidence needed to help children grieve life’s losses in healthy ways.
      </p>
    )
  },
  {
    title: 'Deuildesados.ca',    
    imageUrl: '/img/general/youth-grief.ca.png',
    siteUrl:'https://deuildesados.ca/',
    text: (
      <p className="my-20 colorNavy">
          <a 
            className={styles.http_link} 
            href={"https://deuildesados.ca/"} 
            target={'_blank'}
          >Deuildesados.ca {''}</a>
          has been developed — from content to art to design — by grieving youth, for grieving youth. 
          It shares wisdom, experiences, and advice from more than 30 young people who’ve been there and know what 
          it’s like to grieve when someone you care about has died.
        </p>
    )
  }
]

export const resourcesItemVac = [
  {
    title: 'ShapedByService.ca – Navigating life, loss and change after service',
    imageUrl: '',
    siteUrl:'http://www.shapedbyservice.ca/',
    text: (
      <p className="my-20 colorNavy">
        <a
          className={styles.http_link}
          href="http://www.shapedbyservice.ca/"
          target={'_blank'}
          rel="noreferrer"
        >
          ShapedByService.ca
        </a>
        {' '}is a free resource developed with Veterans of the Canadian Armed Forces and the Royal Canadian Mounted Police, their families, and grief experts to support Veterans and their families in grief experiences related to service and transition out of service.
      </p>
    )
  },
  {
    title: 'ATLAS Resources Directory',    
    imageUrl: '',
    siteUrl:'https://atlasveterans.ca/directory-of-services/',
    text: (
      <p className="my-20 colorNavy">        
        <a 
          className={styles.http_link} 
          href={"https://atlasveterans.ca/directory-of-services/"} 
          target={'_blank'}
        >This webpage {''}</a> contains a list of resources available for military and Royal Canadian Mounted Police (RCMP) Veterans and their families in Canada. The resources are divided by category.
      </p>
    )
  },
  {
    title: 'The Veteran Hub',    
    imageUrl: '',
    siteUrl:'https://www.veteranhub.ca/',
    text: (
      <p className="my-20 colorNavy">        
      <a 
          className={styles.http_link} 
          href={"https://www.veteranhub.ca/"} 
          target={'_blank'}
        >The Veteran Hub</a>, hosted by True Patriot Love, helps connect Veterans, serving members, and their families with services, volunteer opportunities, and events in their local communities.
      </p>
    )
  },
  {
    title: 'AboutGrief.ca',
    imageUrl: '',
    siteUrl:'https://aboutgrief.ca',
    text: (
      <p className="my-20 colorNavy">
        <a 
          className={styles.http_link} 
          href={"https://aboutgrief.ca"} 
          target={'_blank'}
        >AboutGrief.ca {''}</a>
        is a free resource developed by the Canadian Grief Alliance with grief specialists and members of the public who shared their diverse grief experiences, challenges, and what helped them. Articles, resources, and videos provide practical and helpful information you can trust about the grief that may be experienced with death and non-death losses. The list of Programs and Services can help you to find and access other supports.
      </p>
    )
  },
  {
    title: 'MyGrief.ca',    
    imageUrl: '',
    siteUrl:'https://www.mygrief.ca',
    text: (
        <>
        <p className="my-20 colorNavy">
          Confidential and free,
          <a 
            className={styles.http_link} 
            href={"https://www.mygrief.ca"} 
            target={'_blank'}
          >{''} MyGrief.ca {''}</a>
         helps you to understand and respond to your grief. It includes information tailored to specific relationship losses (for example, death of a spouse, parent, colleague, child) and situations (for example, suicide, substance-related deaths, traumatic loss, prolonged grief).
        </p>
        <ul className='colorNavy'>
          <li className={styles.list_item}>
            <span className={`${styles.list_dot} ${styles['no-indent-dot']}`}></span>From the comfort of your home
          </li>
          <li className={styles.list_item}>
            <span className={`${styles.list_dot} ${styles['no-indent-dot']}`}></span>At your own pace
          </li>
          <li className={styles.list_item}>
            <span className={`${styles.list_dot} ${styles['no-indent-dot']}`}></span>Developed by people who have "been there" and grief specialists
          </li>
        </ul>
        </>
    )
  },
  {
    title: 'KidsGrief.ca',    
    imageUrl: '',
    siteUrl:'https://www.kidsgrief.ca',
    text: (
      <p className="my-20 colorNavy">
        <a 
          className={styles.http_link} 
          href={"https://www.kidsgrief.ca"} 
          target={'_blank'}
        >KidsGrief.ca {''}</a>
       is a free online resource that helps parents support their children when someone in their life is dying or has died. It features real-life stories and experiences, and it equips parents with the words and confidence needed to help children grieve life’s losses and develop coping skills that they will have throughout their lives.
      </p>
    )
  },
  {
    title: 'YouthGrief.ca',    
    imageUrl: '',
    siteUrl:'https://youthgrief.ca',
    text: (
      <p className="my-20 colorNavy">
          <a 
            className={styles.http_link} 
            href={"https://youthgrief.ca"} 
            target={'_blank'}
          >YouthGrief.ca {''}</a>
          shares the stories, and art of more than 30 grieving youth, for grieving youth who experienced a significant loss. It is an excellent resource for youth and adults alike to help better understand the complexities grieving youth face at school, at home, and with friends.
        </p>
    )
  }
]

export const resourcesItemVacFR = [
  {
    title: 'DeuilVeteransFamilles.ca – Pour mieux vivre la vie, la perte et les changements après le service',
    imageUrl: '',
    siteUrl:'http://www.deuilveteransfamilles.ca',
    text: (
      <p className="my-20 colorNavy">
        <a
          className={styles.http_link}
          href="http://www.deuilveteransfamilles.ca"
          target={'_blank'}
          rel="noreferrer"
        >
          DeuilVeteransFamilles.ca
        </a>
        {' '}est un site gratuit développé en collaboration avec des personnes vétéranes des Forces armées canadiennes et de la Gendarmerie royale du Canada, leurs familles et des spécialistes deuil afin d'aider les personnes vétéranes et leurs familles à vivre des expériences de deuil en lien avec le service et faciliter la transition vers la vie civile.
      </p>
    )
  },
  {
    title: 'Répertoire des ressources ATLAS',    
    imageUrl: '',
    siteUrl:'https://atlasveterans.ca/fr/repertoire-des-services/',
    text: (
      <p className="my-20 colorNavy">        
        <a 
          className={styles.http_link} 
          href={"https://atlasveterans.ca/fr/repertoire-des-services/"} 
          target={'_blank'}
        >Cette page Web {''}</a> présente une liste de ressources à la disposition des personnes vétéranes des Forces armées canadiennes et de la Gendarmerie royale du Canada (GRC) ainsi que des membres de leurs familles au Canada. Les ressources sont classées par catégories.
      </p>
    )
  },
  {
    title: 'Le Carrefour des anciens combattants',    
    imageUrl: '',
    siteUrl:'https://www.veteranhub.ca/fr/',
    text: (
      <p className="my-20 colorNavy">        
      <a 
          className={styles.http_link} 
          href={"https://www.veteranhub.ca/fr/"} 
          target={'_blank'}
        >Le Carrefour des anciens combattants</a>, hébergé par True Patriot Love, met les personnes vétéranes, les militaires en service et leurs familles en relation avec des services, des activités de bénévolat et des événements locaux.
      </p>
    )
  },
  {
    title: 'LeDeuil.ca',
    imageUrl: '',
    siteUrl:'http://ledeuil.ca/',
    text: (
      <p className="my-20 colorNavy">
        <a 
          className={styles.http_link} 
          href={"http://ledeuil.ca/"} 
          target={'_blank'}
        >LeDeuil.ca {''}</a>
        est un site gratuit développé par l’Alliance canadienne pour le deuil avec la collaboration de spécialistes du deuil et de personnes venues témoigner de leurs diverses expériences de deuil, des difficultés qu’elles ont vécues et de ce qui leur a fait du bien. On y trouve de l’information pratique, utile et fiable sur les pertes liées ou non à un décès, sous la forme d’articles, de ressources et de vidéos. La liste des programmes et services est utile pour trouver d'autres services de soutien.
      </p>
    )
  },
  {
    title: 'MonDeuil.ca',    
    imageUrl: '',
    siteUrl:'http://mondeuil.ca/',
    text: (
      <>
      <p className="my-20 colorNavy">
           Confidentiel et gratuit, 
          <a 
            className={styles.http_link} 
            href={"http://mondeuil.ca/"} 
            target={'_blank'}
          > MonDeuil.ca {''}</a>
          vous aidera à comprendre votre deuil et à y faire face. On y trouve de l’information par type de relation (par exemple, décès du conjoint, d’un parent, d’une collègue, d’un enfant) et de situation (par exemple, suicide, consommation de substances, perte traumatique, deuil prolongé).
        </p>
        <ul className='colorNavy'>
          <li className={styles.list_item}>
            <span className={`${styles.list_dot} ${styles['no-indent-dot']}`}></span>Dans le confort de votre foyer
          </li>
          <li className={styles.list_item}>
            <span className={`${styles.list_dot} ${styles['no-indent-dot']}`}></span>À votre rythme
          </li>
          <li className={styles.list_item}>
            <span className={`${styles.list_dot} ${styles['no-indent-dot']}`}></span>Développé par des personnes qui sont « passées par là » et des spécialistes du deuil
          </li>
        </ul>
      </>
    )
  },
  {
    title: 'DeuilDesEnfants.ca',    
    imageUrl: '',
    siteUrl:'https://deuildesenfants.ca/',
    text: (
      <p className="my-20 colorNavy">
        <a 
          className={styles.http_link} 
          href={"https://deuildesenfants.ca/"} 
          target={'_blank'}
        >DeuilDesEnfants.ca {''}</a>
      est un site gratuit qui aide les parents à accompagner leurs enfants lorsqu'une personne qui leur est chère est en train de mourir ou est décédée. On y trouve des témoignages et des expériences authentiques ainsi que des manières de dire les choses avec assurance pour aider les enfants à faire le deuil de leurs pertes et à développer des capacités d'adaptation qui leur serviront toute leur vie.
      </p>
    )
  },
  {
    title: 'DeuilDesAdos.ca',    
    imageUrl: '',
    siteUrl:'https://deuildesados.ca/',
    text: (
      <p className="my-20 colorNavy">
          <a 
            className={styles.http_link} 
            href={"https://deuildesados.ca/"} 
            target={'_blank'}
          >DeuilDesAdos.ca {''}</a>
          ce site présente des témoignages et des œuvres d’une trentaine de jeunes en deuil et s’adresse à des jeunes en deuil qui ont subi une grande perte. Pour les jeunes comme pour les adultes, c’est une excellente ressource pour mieux comprendre les complexités du deuil chez les jeunes dans leur vie scolaire, familiale et sociale.
        </p>
    )
  }
]
